import React, { useEffect, useState, useRef, useMemo } from 'react';
import Header from './Header';
import { NavLink, useLocation } from 'react-router-dom';
import '../style/BooksScreen.css';
import Footer from './Footer';
import { buildApiUrl, buildImageUrl, getApiBaseUrl } from '../utils/apiClient';

function useQuery() {
	return new URLSearchParams(useLocation().search);
}

function BooksScreen() {
	const query = useQuery();
	const categoryId = query.get("category_id");
	const [allBooks, setAllBooks] = useState([]);
	const [categories, setCategories] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState(categoryId ? parseInt(categoryId, 10) : 0);
	const [filter, setFilter] = useState('Being_Sold');
	const [isDropdownOpen, setDropdownOpen] = useState(false);

	const buttonRefs = useRef({});

	console.log('Resolved API base URL:', getApiBaseUrl());

	// Fetch categories
	useEffect(() => {
		const fetchCategories = async () => {
			const response = await fetch(buildApiUrl('/api/categories'), { credentials: 'include' });
			const data = await response.json();
			console.log('Fetched categories:', data); // Log fetched categories
			setCategories(data);

		};

		fetchCategories();
	}, [categoryId]);

	// Fetch books
	useEffect(() => {
		const fetchBooks = async () => {
			const sortBooks = (items) => {
				return [...items].sort((a, b) => {
					const yearDiff = (b.publishmentYear || 0) - (a.publishmentYear || 0);
					if (yearDiff !== 0) {
						return yearDiff;
					}
					return (b.ID || 0) - (a.ID || 0);
				});
			};

			try {
				const response = await fetch(buildApiUrl('/api/books'), { credentials: 'include' });
				if (!response.ok) {
					console.error('Failed to fetch books: non-OK response', {
						status: response.status
					});
					return;
				}

				const data = await response.json();
				console.log('Fetched all books:', data); // Log all books
				setAllBooks(sortBooks(data));
			} catch (error) {
				console.error('Failed to fetch books:', error);
				setAllBooks([]);
			}
		};

		fetchBooks();
	}, []);

	useEffect(() => {
		if (categoryId) {
			const parsed = parseInt(categoryId, 10);
			setSelectedCategory(Number.isNaN(parsed) ? 0 : parsed);
		} else {
			setSelectedCategory(0);
		}
	}, [categoryId]);

	const filteredBooks = useMemo(() => {
		const selectedCatId = Number.isNaN(selectedCategory) ? 0 : parseInt(selectedCategory, 10);
		const isBookBeingSold = (book) => book.isBeingSold === true || book.status === 'EBOOK';
		let baseBooks = allBooks;
		if (selectedCatId) {
			baseBooks = allBooks.filter(b => b.categoryID === selectedCatId);
		}

		switch (filter) {
			case 'Being_Sold':
				return baseBooks.filter(isBookBeingSold);
			case 'Michail_Pervov':
				return baseBooks.filter(b => b.isPervovs === true);
			case 'Publishment':
				return baseBooks.filter(b => b.isPervovs === false);
			default:
				return baseBooks;
		}
	}, [filter, allBooks, selectedCategory]);

	useEffect(() => {
		if (!allBooks.length) {
			return;
		}
		if (filter === 'Being_Sold' && filteredBooks.length === 0) {
			setFilter('Michail_Pervov');
		} else if (filter === 'Michail_Pervov' && filteredBooks.length === 0) {
			setFilter('Publishment');
		}
	}, [filteredBooks.length, filter, allBooks.length]);
	const buttonMapping = {
		'Being_Sold': 'Сегодня в продаже',
		'Michail_Pervov': 'Книги Михаила Первова',
		'Publishment': 'Книги издательства'
	};

	return (
		<div>
			<div className="header-bg-default">
				<Header />
			</div>
			<div className="filter-container">
				<div className="filter-buttons">
					{Object.keys(buttonMapping).map(buttonKey => (
						<button
							key={buttonKey}
							ref={ref => buttonRefs.current[buttonKey] = ref}
							onClick={() => {
								setFilter(buttonKey);
							}}
							className={`custom-button ${filter === buttonKey ? 'active' : ''}`}
						>
							{buttonMapping[buttonKey]} {/* Use the button mapping here */}
							{filter === buttonKey && <div className="highlight-line"></div>}
						</button>
					))}
				</div>

				{/* Category Dropdown */}
				<div className="dropdown-container">
					<select
						className="category-dropdown"
						value={Number.isNaN(selectedCategory) ? 0 : selectedCategory}
						onChange={e => {
							const parsedValue = parseInt(e.target.value, 10);
							setSelectedCategory(Number.isNaN(parsedValue) ? 0 : parsedValue);
						}}
						onClick={() => setDropdownOpen(prev => !prev)}
					>
						<option value={0}>Жанры</option>
						{categories.map(cat => (
							<option key={cat.ID} value={cat.ID}>{cat.name}</option>
						))}
					</select>
					<img
						src={isDropdownOpen ? '/arrow_up.svg' : '/arrow_down.svg'}
						alt="Dropdown icon"
						className="dropdown-icon"
					/>
				</div>
			</div>

			<hr className="gray-line" />

			{/* Books List */}
			<div className="books-list">
				{filteredBooks.map(book => (
					<NavLink key={book.ID} to={`/book/${book.ID}`}>
						<div className="book">
							<div className="book-year">{book.publishmentYear}</div>
						<img src={buildImageUrl(book.imageURL)} alt={book.name} />
							<div className="book-name">{book.name}</div>
						</div>
					</NavLink>
				))}
			</div>
			<Footer />
		</div>
	);
}

export default BooksScreen;
